import { Box, Switch, Typography } from "@mui/material";
import React from "react";

const SkillMatrixExport = ({
                           newAddOnSettings,
                           setNewAddOnSettings,
                       }: any) => {
    const skillsMatrixExportEnabled = newAddOnSettings.skillsMatrixExportEnabled;

    return (
        <Box
            sx={{
                marginTop: "20px",
                marginBottom: "8px",
                borderRadius: "8px",
                border: 1,
                borderWidth: "1px",
                borderColor: "rgba(0,0,0,0.12)",
                background: "#FFF",
                padding: "16px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0px 16px",
                    alignItems: "center",
                }}
            >
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                }}>
                    <Typography
                        sx={{
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            fontSize: "16px",
                            color: "rgba(0, 0, 0, 0.87)",
                        }}
                    >
                        Enable Skills Matrix Export
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "rgba(0, 0, 0, 0.6)",
                        }}
                    >
                        Allow users to export the skills matrix data.
                    </Typography>
                </Box>
                <Switch
                    checked={skillsMatrixExportEnabled ?? false}
                    onChange={(e) => {
                        setNewAddOnSettings((pre: any) => {
                            return {
                                ...pre,
                                skillsMatrixExportEnabled: e.target.checked,
                            };
                        });
                    }}
                />
            </Box>
        </Box>
    );
};

export default SkillMatrixExport;
